import React, { useContext } from "react";
import { Container } from "react-bootstrap";
import classes from "./OurServices.module.css";
import { MyContext } from "../../Context/MyContext";

import webDevelopment from "../../Assets/webDevelopment.jpg";
import mobileDevelopment from "../../Assets/mobileDevelopment.jpg";
import socialMediaMarketing from "../../Assets/socialMediaMarketing.jpg";
import emailMarketing from "../../Assets/emailMarketing.jpg";
import virtualAssistant from "../../Assets/virtualAssistant.jpg";
import graphicDesigning from "../../Assets/graphicDesigning.jpg";
import aboutUs from "../../Assets/aboutUs.jpg";
import RenderColService from "./RenderColService";

const services = [
  {
    image: webDevelopment,
    title: "Web Solutions",
    hook: "Launch a site that looks sharp, loads fast, and turns visitors into customers.",
    deliverables: [
      "Custom websites and web apps for marketing, portals, and e-commerce",
      "Responsive UI, SEO-ready structure, and analytics",
      "Iteration after launch so the site keeps converting",
    ],
    bestFor: "Brands that need a credible, conversion-focused web presence.",
  },
  {
    image: mobileDevelopment,
    title: "Mobile Applications",
    hook: "Put your product in your customers’ pocket with an iOS and Android app they actually enjoy using.",
    deliverables: [
      "Apps for iOS and Android with a native feel",
      "UX, performance, and store-ready builds",
      "Secure, scalable architecture from day one",
    ],
    bestFor: "Teams ready to extend their product beyond the browser.",
  },
  {
    image: aboutUs,
    title: "AI Automations & GoHighLevel",
    hook: "Connect your CRM, inbox, and follow-up so leads get answered, booked, and nurtured — without a bigger headcount.",
    deliverables: [
      "GoHighLevel setup: pipelines, calendars, funnels, and snapshots",
      "AI chat, SMS, and voice agents that qualify and book",
      "Workflows for lead routing, reminders, and reporting",
    ],
    bestFor: "Agencies and operators who want GHL and AI doing the follow-up.",
  },
  {
    image: socialMediaMarketing,
    title: "Social Media Marketing",
    hook: "Show up where your buyers already spend time — and turn attention into inquiries.",
    deliverables: [
      "Channel strategy for Instagram, Facebook, LinkedIn, TikTok, and X",
      "Content calendars, creative, and community management",
      "Reporting tied to reach, engagement, and leads",
    ],
    bestFor: "Businesses that need a steady, professional social presence.",
  },
  {
    image: emailMarketing,
    title: "Email Marketing",
    hook: "Reach the right people with messages that get opened, clicked, and remembered.",
    deliverables: [
      "Campaign strategy, copy, and design",
      "Segmentation, automation, and list hygiene",
      "Performance tracking against revenue goals",
    ],
    bestFor: "Teams who already have an audience and want it to pay off.",
  },
  {
    image: graphicDesigning,
    title: "Graphic Design",
    hook: "Give every touchpoint a look that feels like one brand — not a pile of mismatched files.",
    deliverables: [
      "Brand identity, logos, and visual systems",
      "Social, web, and print assets",
      "Templates your team can keep using",
    ],
    bestFor: "Companies that need a clear, consistent visual identity.",
  },
  {
    image: virtualAssistant,
    title: "Admin Virtual Assistants",
    hook: "Hand off the inbox, calendar, and busywork so you can stay on the work that grows the business.",
    deliverables: [
      "Email, scheduling, and calendar management",
      "Data entry, research, and reporting",
      "Customer support coverage",
    ],
    bestFor: "Founders and teams who are drowning in admin.",
  },
];

function OurServices() {
  const { serviceRef } = useContext(MyContext);

  return (
    <section ref={serviceRef} className="sectionShell" id="services">
      <Container>
        <div className={classes.intro}>
          <div className="sectionEyebrow">What we do</div>
          <h2 className="sectionTitle">Services built to win you customers</h2>
          <p className="sectionLead">
            Software, marketing, AI automations, and operational support —
            scoped to what your business needs next, not a generic package.
          </p>
        </div>
        <div className={classes.list}>
          {services.map((service, index) => (
            <RenderColService
              key={service.title}
              {...service}
              reverse={index % 2 === 1}
            />
          ))}
        </div>
      </Container>
    </section>
  );
}

export default OurServices;
